import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from "react";
import PropTypes from "prop-types";
import mergeDiff from "./mergeDiff";

var EnterLeaveGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EnterLeaveGroup, _React$Component);

  EnterLeaveGroup.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var keysAndData = props.keysAndData,
        leaveStyle = props.leaveStyle,
        enterPositionStyle = props.enterPositionStyle,
        enterDecorationStyle = props.enterDecorationStyle;
    var oldKeysAndData = state.keysAndDataToRender;
    var enteringKeys = {};
    var leavingKeys = {};
    var keysAndDataToRender = mergeDiff(oldKeysAndData, keysAndData, function (oldKeyIndex, content) {
      if (!props.leaveStyle) return null;
      leavingKeys[content.key] = leaveStyle;
      return content;
    }, function (newKeyIndex, content) {
      enteringKeys[content.key] = {
        positionStyle: enterPositionStyle,
        decorationStyle: enterDecorationStyle
      };
    });
    return {
      keysAndDataToRender: keysAndDataToRender,
      leavingKeys: leavingKeys,
      enteringKeys: enteringKeys
    };
  };

  function EnterLeaveGroup(props) {
    var _this = _React$Component.call(this, props) || this;

    _this.registerNode = function (key, opts) {
      var registerNode = _this.props.registerNode;
      var _this$state = _this.state,
          enteringKeys = _this$state.enteringKeys,
          leavingKeys = _this$state.leavingKeys;

      var passedOpts = _extends({}, opts, {
        _passInfo: true,
        isEnteringWithStyles: enteringKeys[key],
        isLeaving: leavingKeys[key] && {
          finalStyle: leavingKeys[key],
          onDone: function onDone() {
            return _this.setState(function (_ref) {
              var keysAndDataToRender = _ref.keysAndDataToRender;
              return {
                keysAndDataToRender: keysAndDataToRender.filter(function (knd) {
                  return knd.key !== key;
                })
              };
            });
          }
        }
      });

      var nodeInfo = registerNode(key, passedOpts);
      _this.nodeInfoPerKey[key] = nodeInfo;
      return nodeInfo.handler;
    };

    _this.state = {
      keysAndDataToRender: [],
      enteringKeys: {},
      leavingKeys: {}
    };
    _this.nodeInfoPerKey = {};
    return _this;
  }

  var _proto = EnterLeaveGroup.prototype;

  _proto.render = function render() {
    var keysAndDataToRender = this.state.keysAndDataToRender;
    var children = this.props.children;
    return children(keysAndDataToRender, this.registerNode);
  };

  return EnterLeaveGroup;
}(React.Component);

export { EnterLeaveGroup as default };
process.env.NODE_ENV !== "production" ? EnterLeaveGroup.propTypes = {
  keysAndData: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    data: PropTypes.any
  })).isRequired,
  registerNode: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  leaveStyle: PropTypes.object,
  enterPositionStyle: PropTypes.object,
  enterDecorationStyle: PropTypes.object
} : void 0;